import { Add } from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import { MouseEventHandler, memo } from 'react';
import { useTranslation } from 'react-i18next';

import { OrderItemQuantityPicker } from 'shared/ui/OrderItemQuantityPicker';

interface AddCatalogItemWithQtyProps {
    active: boolean;
    value: number;
    loading: boolean;
    disabledAddButton?: boolean;
    onSetValue: (value: number) => void;
    onItemToggleSelect: () => void;
}

export const AddCatalogItemWithQty = memo(
    ({
        active,
        loading,
        value,
        disabledAddButton = false,
        onSetValue,
        onItemToggleSelect,
    }: AddCatalogItemWithQtyProps) => {
        const { t } = useTranslation();

        const preventDefaultContainerClick: MouseEventHandler<
            HTMLDivElement
        > = (e) => {
            e.stopPropagation();
        };

        return (
            <Box
                sx={{ display: 'flex', justifyContent: 'flex-end' }}
                onClick={preventDefaultContainerClick}
            >
                {active ? (
                    <OrderItemQuantityPicker
                        showDeleteButton
                        minQuantity={1}
                        value={value}
                        onQuantityChange={(newQuantity) => {
                            onSetValue(newQuantity);
                        }}
                        disabled={loading}
                    />
                ) : (
                    <Button
                        data-testclass="catalog-add-item-btn"
                        variant="contained"
                        size="small"
                        onClick={onItemToggleSelect}
                        disabled={loading || disabledAddButton}
                        startIcon={<Add sx={{ fontSize: '2rem !important' }} />}
                        sx={{
                            height: '32px',
                            textTransform: 'none',
                            borderRadius: '4px',
                            paddingLeft: '8px',
                            paddingRight: '12px',
                            '& >.MuiButton-icon': {
                                marginRight: 0,
                            },
                            ...(disabledAddButton && {
                                '&.Mui-disabled': {
                                    opacity: 1,
                                    color: '#FFF',
                                    backgroundColor: 'rgba(0, 0, 0, 0.14)',
                                    boxShadow: 'none',
                                    '& .MuiButton-startIcon': {
                                        color: 'inherit',
                                    },
                                },
                            }),
                        }}
                    >
                        {t('Add')}
                    </Button>
                )}
            </Box>
        );
    },
);
